module.exports = __webpack_public_path__ + "img/picture.e8df620e.png";